common.View.create('website::layouts.Main', {

    onDOMLoad()
    {
        this.initSlider();
    },

    initSlider() {
        let owlCarousel = $('header .owl-carousel');

        if (!owlCarousel.hasClass('disable-slider')) {
            owlCarousel.owlCarousel({
                items: 1,
                loop: owlCarousel.find('> *').length > 1,
                autoplay: true,
                animateIn: 'fadeIn', // add this
                animateOut: 'fadeOut', // and this
                autoplayTimeout: 4000,
                autoplayHoverPause: true,
                autoplaySpeed: 1000,
                stageClass: 'owl-stage h-full',
                stageOuterClass: 'owl-stage-outer h-full',
                itemClass: 'owl-item h-full',
            });
        }
    },
});
